import PropTypes from 'prop-types'
import React from 'react'
import { SaxsExperiment } from './SaxsExperiment'
import SaxsSearchBarBelowEntityList from '../SaxsSearchBarBelowEntityList'
import filter from 'lodash/filter'

class SaxsExperimentListPanel extends React.Component {
  constructor(props) {
    super(props)

    this.filter = this.filter.bind(this)
  }

  render() {
    return (
      <SaxsSearchBarBelowEntityList data={this.props.experiments} filter={this.filter} placeholder="Search by name">
        {foundExperiments => (
          <div>
            <div style={{ paddingLeft: '8px' }}>
              <strong> {foundExperiments.length} </strong> experiments found.
            </div>
            {foundExperiments.map((experiment, index) => (
              <SaxsExperiment
                key={index}
                backgroundColorCode={index % 2}
                comments={experiment.comments}
                creationDate={experiment.creationDate}
                dataAcquisitionFilePath={experiment.dataAcquisitionFilePath}
                dataCollectionCount={experiment.dataCollectionCount}
                dataCollectionDoneCount={experiment.dataCollectionDoneCount}
                experiment={experiment}
                experimentId={experiment.id}
                experimentType={experiment.type}
                isSelected={this.props.selectedExperimentId === experiment.id}
                macromolecules={experiment.macromolecules}
                measurementAveragedCount={experiment.measurementAveragedCount}
                measurementCount={experiment.measurementCount}
                measurementDoneCount={experiment.measurementDoneCount}
                name={experiment.name}
                onExperimentClicked={this.props.onExperimentClicked}
                proposalId={experiment.proposalId}
                sessionId={experiment.sessionId}
                sourceFilePath={experiment.sourceFilePath}
                specimenCount={experiment.specimenCount}
                status={experiment.status}
              />
            ))}
          </div>
        )}
      </SaxsSearchBarBelowEntityList>
    )
  }

  filter(data, userInput) {
    return filter(data, item => item.name.toUpperCase().indexOf(userInput.toUpperCase()) !== -1)
  }
}

export default SaxsExperimentListPanel

SaxsExperimentListPanel.propTypes = {
  /** Expeirment list */
  experiments: PropTypes.array.isRequired,
  /** selected experiment id */
  selectedExperimentId: PropTypes.number,
  /** Callback triggered when the user clicks on the experiment */
  onExperimentClicked: PropTypes.func,
}
